import { Eye, Search } from "lucide-react";
import { ToastMessages } from "../../shared/ToastMessages";
import { useSuperAdminJobsPendingApprovalViewModel } from "./view_model/super_admin_viewmodel";
import SuperAdminJobPendingApprovalCard from "./component/super_admin_pending_card";
import RejectCommentModal from "../company/JobManagement/Components/RejectCommentModal";
import TablePagination from "../company/JobManagement/Components/TablePagination";
import {formatDateTime} from "../../utils/datetime"
export const PendingJobs = () => {
  const {
    state,
    tabs,
    summaryCards,
    historyRows,
    hasHistoryFilters,
    handleTabChange,
    handleHistoryStatusFilter,
    updateHistorySearchTerm,
    applyHistorySearch,
    clearHistoryFilters,
    handlePageChange,
    handleRowsPerPageChange,
    handlePendingPageChange,
    handlePendingRowsPerPageChange,
    toggleJobMenu,
    handleAction,
    handleViewApproval,
    toast,
    closeToast,
    rejectModal,
    updateRejectReason,
    closeRejectModal,
    submitRejectModal,
  } = useSuperAdminJobsPendingApprovalViewModel();

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Jobs</h1>
      </div>
      <div>
        <div className="mb-6 border-b border-gray-200">
          <nav className="-mb-px flex gap-6">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                onClick={() => handleTabChange(tab.key)}
                className={`border-b-2 px-1 pb-3 text-sm font-medium ${
                  state.activeTab === tab.key
                    ? "border-blue-500 text-blue-600"
                    : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                }`}
              >
                {tab.label}
                <span className="ml-2 rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-600">
                  {tab.count}
                </span>
              </button>
            ))}
          </nav>
        </div>

        {state.activeTab === "pending" ? (
          state.pendingLoading ? (
            <div className="px-6 py-12 text-center text-sm text-gray-500">
              Loading pending approvals...
            </div>
          ) : state.pendingError ? (
            <div className="rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
              {state.pendingError}
            </div>
          ) : state.pendingApprovals.length === 0 ? (
            <div className="px-6 py-12 text-center">
              <svg
                className="mx-auto h-12 w-12 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2-2v2m8 0V6a2 2 0 012 2v6a2 2 0 01-2 2H8a2 2 0 01-2-2V8a2 2 0 012-2h8z"
                />
              </svg>
              <h3 className="mt-2 text-sm font-medium text-gray-900">
                No Pending Approvals found
              </h3>
            </div>
          ) : (
            <div className="space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 items-stretch">
                {state.pendingApprovals.map((pending) => (
                  <SuperAdminJobPendingApprovalCard
                    key={pending.job_id}
                    jobPending={pending}
                    onAction={handleAction}
                    openMenuJobId={state.openMenuJobId}
                    onToggleMenu={toggleJobMenu}
                  />
                ))}
              </div>

              {state.pendingTotalCount > state.pendingRowsPerPage && (
                <TablePagination
                  currentPage={state.pendingCurrentPage}
                  totalCount={state.pendingTotalCount}
                  rowsPerPage={state.pendingRowsPerPage}
                  onPageChange={handlePendingPageChange}
                  onRowsPerPageChange={handlePendingRowsPerPageChange}
                />
              )}
            </div>
          )
        ) : (
          <div className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
              {summaryCards.map((card) => (
                <button
                  key={card.label}
                  type="button"
                  onClick={() => handleHistoryStatusFilter(card.filter)}
                  className={`text-left bg-white rounded-md border border-l-4 ${
                    card.accent
                  } p-3 shadow-sm transition hover:border-gray-300 ${
                    state.historyStatusFilter === card.filter
                      ? "ring-2 ring-blue-100 border-blue-300"
                      : ""
                  }`}
                >
                  <p className="text-xs font-medium text-gray-500">
                    {card.label}
                  </p>
                  <p className="mt-1 text-xl font-semibold text-gray-900">
                    {card.value}
                  </p>
                </button>
              ))}
            </div>

            <form
              onSubmit={(event) => {
                event.preventDefault();
                applyHistorySearch();
              }}
              className="flex flex-col gap-4 sm:flex-row"
            >
              <div className="flex-1">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Search by company or job..."
                    value={state.historySearchTerm}
                    onChange={(event) =>
                      updateHistorySearchTerm(event.target.value)
                    }
                    className="w-full rounded-lg border border-gray-300 py-2 pl-10 pr-4 focus:border-transparent focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={state.historyLoading}
                className="inline-flex items-center justify-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-blue-300"
              >
                <Search className="h-4 w-4" />
                <span>Search</span>
              </button>

              {hasHistoryFilters && (
                <button
                  type="button"
                  onClick={clearHistoryFilters}
                  className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 hover:text-gray-800"
                >
                  Clear
                </button>
              )}
            </form>

            {state.historyError && (
              <div className="rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
                {state.historyError}
              </div>
            )}

            <div className="overflow-hidden rounded-md border border-gray-200 bg-white shadow-sm">
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200 text-sm">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">
                        Company Name
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">
                        Status
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">
                        Submitted At
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">
                        Reviewed At
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">
                        Reviewed By Name
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">
                        Rejection Reason
                      </th>
                      <th className="px-4 py-3 text-right text-xs font-semibold uppercase tracking-wide text-gray-500">
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100 bg-white">
                    {state.historyLoading ? (
                      <tr>
                        <td
                          colSpan={7}
                          className="px-4 py-12 text-center text-sm text-gray-500"
                        >
                          Loading approval history...
                        </td>
                      </tr>
                    ) : historyRows.length > 0 ? (
                      historyRows.map((row) => (
                        <tr key={row.key} className="hover:bg-gray-50">
                          <td className="px-4 py-3 text-gray-900">
                            <div className="font-medium">{row.companyName}</div>
                            {row.showJobTitle && (
                              <div className="mt-0.5 text-xs text-gray-500">
                                {row.jobTitle}
                              </div>
                            )}
                          </td>
                          <td className="px-4 py-3">
                            <span
                              className={`inline-flex rounded px-2 py-1 text-xs font-semibold ${row.statusPillClasses}`}
                            >
                              {row.statusLabel}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-gray-600">
                            {formatDateTime(row.submittedAt)}
                          </td>
                          <td className="px-4 py-3 text-gray-600">
                            {formatDateTime(row.reviewedAt)}
                          </td>
                          <td className="px-4 py-3 text-gray-600">
                            {row.reviewedByName}
                          </td>
                          <td className="max-w-xs px-4 py-3 text-gray-600">
                            <span className="line-clamp-2">
                              {row.rejectionReason}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-right">
                            <button
                              type="button"
                              onClick={() => handleViewApproval(row.source)}
                              className="inline-flex items-center gap-1 text-sm font-medium text-blue-600 hover:text-blue-900"
                              title="View approval details"
                            >
                              <Eye className="h-4 w-4" />
                              <span>View</span>
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={7}
                          className="px-4 py-12 text-center text-sm text-gray-500"
                        >
                          No approvals history found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {state.historyTotalCount > state.rowsPerPage && (
                <TablePagination
                  currentPage={state.currentPage}
                  totalCount={state.historyTotalCount}
                  rowsPerPage={state.rowsPerPage}
                  onPageChange={handlePageChange}
                  onRowsPerPageChange={handleRowsPerPageChange}
                />
              )}
            </div>
          </div>
        )}
        {rejectModal && (
          <RejectCommentModal
            comment={rejectModal.rejectReason}
            onChange={updateRejectReason}
            onSubmit={submitRejectModal}
            onClose={closeRejectModal}
          />
        )}
      </div>
      {toast && (
        <ToastMessages
          message={toast.message}
          type={toast.type}
          onClose={closeToast}
        />
      )}
    </div>
  );
};
